/**
 * First component for mui
 *
 * Loading UI that has a background image with the application title and a progress bar for loading the game assets.
 */
import React from 'react';

import startImg from '../media/1x/01_intro/intro_start-min.png';

import introPoeCenterImg from '../media/2x/01_intro/intro_poe_center_2x-min.png';
import introSoupsOnImg from '../media/SOUPS-ON-Title-1x.png';
import introSoupImg from '../media/2x/01_intro/intro_soup_2x-min.png';

import introLoaderBackground from '../media/2x/01_intro/intro_load_0_2x_notext.png';
import introLoaderPill from '../media/2x/01_intro/intro_load_0_2x_pill.png';
import introLoaderPillLeft from '../media/2x/01_intro/intro_load_0_2x_pill-left.png';
import introLoaderPillRight from '../media/2x/01_intro/intro_load_0_2x_pill-right.png';

import CustomIconButton from '../game/CustomIconButton';


// import { makeStyles } from '@material-ui/core/styles';
import { Button, LinearProgress, linearProgressClasses, Paper, Stack, styled, Typography } from '@mui/material';
// import * as spine from "@esotericsoftware/spine-player";

const BorderLinearProgress = styled(LinearProgress)(({ theme }) => ({
  height: 20,
  borderRadius: 10,
  [`&.${linearProgressClasses.colorPrimary}`]: {
    backgroundColor: theme.palette.grey[theme.palette.mode === 'light' ? 200 : 800],
  },
  [`& .${linearProgressClasses.bar}`]: {
    borderRadius: 10,
    backgroundColor: theme.palette.mode === 'light' ? '#1a90ff' : '#308fe8',
  },
}));

export default function Loader(props) {

  //exeucte after render
  React.useEffect(() => {
    const elements = document.querySelectorAll('.loader-logo-container img');

    elements.forEach((element, index) => {
      const delay = Math.random() * 2; // Adjust the delay range as needed
      const animationName = `jiggle${Math.floor(Math.random() * 3) + 1}`; // Assuming 3 different jiggle animations

      element.style.animation = `${animationName} 3s ease-in-out infinite`;
      element.style.animationDelay = `${delay}s`;
    });
  }, []);



  const handleStart = () => {
    props.navigate('/game');

    //play the background music
    var audio = document.getElementById('background-audio');
    audio.play();
  }

  let loading = props.progress < 100;

  const imgRef = React.useRef(null);

  return (
    <div className="Loader full-screen" style={{ display: 'flex', justifyContent: 'center', alignItems: 'center' }}>
      <div className="background">
        {/* Rotating backround image */}
      </div>
      <div>
        <Stack spacing={1}>

          <div>
            <div className="loader-logo-container">
              {/* Add <img> tags for the images */}
              <img width={312} src={introPoeCenterImg} className="image-2x" alt="Intro Poe Center" />
              
              <img width={530} src={introSoupsOnImg} className="image-2x dynamic-size" alt="Soups On" />
              <img width={628} src={introSoupImg} className="image-2x dynamic-size" alt="Bowl" />
            </div>
          </div>

          <div class="loader-button-container">
            <CustomIconButton
              disabled={loading}
              style={{ background: 'none', boxShadow: 'none', border: 'none', padding: 0 }}
              onClick={handleStart}
            >
              <img ref={imgRef} src={startImg} alt="Start" className={loading ? 'disabled-image' : ''} />
            </CustomIconButton>

          </div>

          <div style={{ position: 'relative'}}>
            <img id='loader' width={550} src={introLoaderBackground} alt='0%' />
            {props.progress > 0 && (
              <img
                id='loader-pill-left'
                height={16}
                width={8}
                src={introLoaderPillLeft}
                alt='0%'
                style={{ position: 'absolute', top: 7, left: 132 }}
              />
            )}
            <img
              id='loader-pill'
              height={16}
              width={(props.progress / 100) * 520}
              src={introLoaderPill}
              alt='0%'
              style={{ position: 'absolute', top: 7, left: 140 }}
            />
            {props.progress > 0 && (
              <img
                id='loader-pill-right'
                height={16}
                width={8}
                src={introLoaderPillRight}
                alt='0%'
                style={{ position: 'absolute', top: 7, left: 140 + (props.progress / 100 * 520) }}
              />
            )}

            {/* Add the text label */}
            <div style={{ position: 'absolute', top: '50%', left: '50%', transform: 'translate(-50%, -50%)', textAlign: 'center' }}>
              <Typography variant="h6" component="p" gutterBottom style={{ color: props.progress <= 60 ? '#fdd89a' : '#522a0f',textTransform:"uppercase",fontSize:"0.8rem" }}>
                Loading {Math.ceil(props.progress)}%
              </Typography>
            </div>

          </div>

          <div>
            <Typography variant="subtitle1" component="p" gutterBottom class="sub-title">
              This material was funded by USDA's Supplemental Nutrition Assistance Program – SNAP.
              This institution is an equal opportunity provider. <a href="https://www.usda.gov/non-discrimination-statement" target='_blank' rel="noreferrer">Learn More</a>
              {/* onClick={()=>{
                //set the model to visible
                var modal = document.getElementById('snapModal');
                modal.style.display = "block";
              }
              }  */}
            </Typography>
          </div>

          <div id="snapModal" class="modal">
            <div class="modal-content">
              <span class="close" onClick={()=>{
                //set the model to hidden
                var modal = document.getElementById('snapModal');
                modal.style.display = "none";
              }}>&times;</span>

              
              <div class="panel-body wpb_accordion_content ui-accordion-content half-internal-gutter single-block-padding snipcss0-0-0-1 snipcss-8BH73">
                <div class="uncode_text_column snipcss0-1-1-2" style={{padding:10}}>
                  <p class="snipcss0-2-2-3">
                    In accordance with Federal law and U.S. Department of Agriculture (USDA) civil rights regulations and policies, this institution is prohibited from discriminating on the basis of race, color, national origin, sex (including gender identity and sexual orientation), religious creed, disability, age, political beliefs, or reprisal or retaliation for prior civil rights activity.
                  </p>
                  <p class="snipcss0-2-2-4">
                    To file a program discrimination complaint, a complainant should complete a <a target='_blank' rel='noreferrer' href="https://www.usda.gov/sites/default/files/documents/USDA-OASCR P-Complaint-Form-0508-0002-508-11-28-17Fax2Mail.pdf">
                      Form AD-3027, USDA Program DiscriminationComplaint Form, which can be obtained online
                    </a>
                    , from any USDA office, by calling (833) 620-1071, or by writing a letter addressed to USDA. The letter must contain the complainant’s name, address, telephone number and a written description of the alleged discriminatory action in sufficient detail to inform the Assistant Secretary for Civil Rights (ASCR) about the nature and date of an alleged civil rights violation. The completed AD-3027 form or letter must be submitted to:
                  </p>
                  <p class="snipcss0-2-2-6">
                    <img decoding="async" class="alignright size-thumbnail wp-image-16587 snipcss0-4-7-8" src="./media/content_media/SNAPed_RGB_stacked-min-150x150.png" alt="" width="150" height="150" style={{ float: 'right' }} />
                    <strong style={{ clear: "both" }}>mail:</strong>
                    <br class="snipcss0-3-6-9" />
                      Food and Nutrition Service, USDA
                    <br class="snipcss0-3-6-10" />
                        1320 Braddock Place, Room 334
                    <br class="snipcss0-3-6-11" />
                          Alexandria, VA 22314; or
                        </p>
                        <p class="snipcss0-2-2-12">
                          <strong class="snipcss0-3-12-13">
                            fax:
                          </strong>
                          (833) 256-1665 or (202) 690-7442; or
                          <br class="snipcss0-3-12-14" />
                            <strong class="snipcss0-3-12-15">
                              email:&nbsp;
                            </strong>
                            <a contentEditable="false" href="mailto:FNSCIVILRIGHTSCOMPLAINTS@usda.gov" target="_blank" rel="noopener noreferrer" class="snipcss0-3-12-16" title="mailto:FNSCIVILRIGHTSCOMPLAINTS@usda.gov">
                              FNSCIVILRIGHTSCOMPLAINTS@usda.gov
                            </a>
                        </p>
                        <p class="snipcss0-2-2-17">
                          This institution is an equal opportunity provider.
                        </p>
                      </div>
                    </div>


            </div>
          </div>

        </Stack>
      </div>
    </div>
  );
}
